import React, { Component } from 'react';
import { Field } from 'redux-form';

import { RadioButtonGroup, TextField, SelectField } from 'redux-form-material-ui';

import FormControlLabel from '@material-ui/core/FormControlLabel';
import Radio from '@material-ui/core/Radio';
import MenuItem from 'material-ui/MenuItem';

import { BooleanRadioButtons } from 'helpers/BooleanRadioButtons';
import * as validator from 'helpers/Validator';
import { getTranslatedString } from 'helpers/i18n';

class MultipleChoiceQuestion extends Component {
  render() {
    return (
      <Field
        name={this.props.fieldName}
        component={RadioButtonGroup}
        validate={validator.required}
        style={{ width: '250px', margin: 'auto' }}
      >
        {this.props.questionOptions.map((option, index) => (
          <FormControlLabel
            value={index.toString()}
            control={<Radio />}
            label={option.option}
            key={index}
            style={{
              padding: '5px 10px 0',
              marginBottom: '5px',
              textAlign: 'initial',
              backgroundImage:
                '-webkit-linear-gradient(right, #f1f1f1, #f1f1f1 210px, transparent 210px, transparent 100%)',
            }}
          />
        ))}
      </Field>
    );
  }
}

class YesNoQuestion extends Component {
  render() {
    return (
      <BooleanRadioButtons name={this.props.fieldName} style={{ width: '187px', margin: 'auto' }} />
    );
  }
}

class FreeFormQuestion extends Component {
  render() {
    return (
      <Field
        name={this.props.fieldName}
        component={TextField}
        hintText={getTranslatedString('tenantPortal.surveys.freeFormQuestion.hint')}
        validate={validator.required}
        hintStyle={{ textAlign: 'center' }}
        multiLine={true}
        fullWidth
        errorStyle={{ display: 'none' }}
        style={{ fontSize: '14px', width: '280px' }}
      />
    );
  }
}

class RatingQuestion extends Component {
  render() {
    return (
      <Field
        name={this.props.fieldName}
        component={SelectField}
        hintText={getTranslatedString('tenantPortal.surveys.ratingQuestion.hint')}
        style={{
          marginTop: '0px',
          fontSize: '14px',
          textAlign: 'left',
          width: '175px',
        }}
        validate={[validator.required]}
        maxHeight={200}
      >
        <MenuItem value={'5'} primaryText={'5'} />
        <MenuItem value={'4'} primaryText={'4'} />
        <MenuItem value={'3'} primaryText={'3'} />
        <MenuItem value={'2'} primaryText={'2'} />
        <MenuItem value={'1'} primaryText={'1'} />
      </Field>
    );
  }
}

class RatingQuestionTen extends Component {
  render() {
    return (
      <Field
        name={this.props.fieldName}
        component={SelectField}
        hintText={getTranslatedString('tenantPortal.surveys.ratingQuestion.hint')}
        style={{
          marginTop: '0px',
          fontSize: '14px',
          textAlign: 'left',
          width: '175px',
        }}
        validate={[validator.required]}
        maxHeight={350}
      >
        <MenuItem value={'10'} primaryText={'10'} />
        <MenuItem value={'9'} primaryText={'9'} />
        <MenuItem value={'8'} primaryText={'8'} />
        <MenuItem value={'7'} primaryText={'7'} />
        <MenuItem value={'6'} primaryText={'6'} />
        <MenuItem value={'5'} primaryText={'5'} />
        <MenuItem value={'4'} primaryText={'4'} />
        <MenuItem value={'3'} primaryText={'3'} />
        <MenuItem value={'2'} primaryText={'2'} />
        <MenuItem value={'1'} primaryText={'1'} />
        <MenuItem value={'0'} primaryText={'0'} />
      </Field>
    );
  }
}

export default class SurveyQuestion extends Component {
  render() {
    const {
      question: { question, question_type, question_option },
      index,
    } = this.props;

    const FREE_FORM = 0;
    const MULTIPLE_CHOICE = 1;
    const TRUE_FALSE = 2;
    const RATING = 3;
    const POLL = 4;
    const RATING_TEN = 5;

    const fieldName = `questions[${index}].answer`;

    const questionComponent = (question_type) => {
      switch (question_type) {
        case FREE_FORM:
          return <FreeFormQuestion fieldName={fieldName} />;
        case MULTIPLE_CHOICE:
          return <MultipleChoiceQuestion questionOptions={question_option} fieldName={fieldName} />;
        case POLL:
          return <MultipleChoiceQuestion questionOptions={question_option} fieldName={fieldName} />;
        case TRUE_FALSE:
          return <YesNoQuestion fieldName={fieldName} />;
        case RATING:
          return <RatingQuestion fieldName={fieldName} />;
        case RATING_TEN:
          return <RatingQuestionTen fieldName={fieldName} />;
        default:
          return null;
      }
    };

    return (
      <div className="row">
        <h5
          style={{
            textAlign: 'center',
            marginBottom: '15px',
            marginTop: '15px',
          }}
        >
          {question}
        </h5>
        <div style={{ marginBottom: '10px' }}>{questionComponent(question_type)}</div>
      </div>
    );
  }
}
